module.exports = __webpack_public_path__ + "img/JobInterview.bc972e19.svg";